export default (dc, { defaultModel, defaultView, ...config }) => {
  const type = 'slider-next'
  const attrKey = config.attrSliderNext
  const classKey = config.classSliderNext

  dc.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Slider Next',
        draggable: false,
        droppable: false,
        copyable: false,
        removable: false,
        ...config.sliderNextProps
      },

      init() {
        const attrs = this.getAttributes()
        attrs[attrKey] = 1
        this.setAttributes(attrs)
        classKey && this.addClass(classKey)
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrKey)) {
          return { type }
        }
      }
    }),
    view: defaultView
  })
}
